import {
  useGlobalCurrency,
  useGlobalPeriod,
  useIncome,
  useReportBespoke,
} from "@iliotech/data-wire";
import { useIncomePageContext } from "@iliotech/data-wire/src/reactHooks/hooks/useIncomePage/IncomePageContext";
import { ColumnChartStacked, ValueLegend } from "src/main";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import { useIncomeByAssetClassWidget } from "./hooks/useIncomeByAssetClassWidget";
import { useParams } from "react-router-dom";

export const IncomeByAssetClassWidget = ({
  height,
  width,
  isHalfHeight,
  periodContext,
  structureContext,
}: ReportWidgetProps) => {
  const { currencyFormatter } = useGlobalCurrency();
  const { portfolioId } = useParams<{ portfolioId: string }>();
  const { periodString } = periodContext || useGlobalPeriod();
  const store = useReportBespoke();
  const generating = store.generating;
  const incomeReport = useIncome(portfolioId!).data?.data as any;
  const { pastIncomeTotals, pastIncomeTitle, pastIncomeData } =
    useIncomeByAssetClassWidget({
      pastIncome: incomeReport?.pastIncome || [],
      periodContext,
      structureContext,
    });

  return (
    <div>
      <h4 className={"element-title"}>{pastIncomeTitle}</h4>
      <p className={"period-string"}>{periodString}</p>
      <ColumnChartStacked
        height={height}
        width={width}
        generating={generating}
        data={pastIncomeData}
        hideLegend
        valueFormatter={currencyFormatter!}
      />
      <ValueLegend small={isHalfHeight} items={pastIncomeTotals} />
    </div>
  );
};
